<script lang="ts" setup>
import { computed, PropType } from "vue";
import { PoolDetails } from "@/models/pool-details.model";
import KlereoSegmentedControl from "@/shared/components/KlereoSegmentedControl.vue";

const props = defineProps({
  out: Object as PropType<PoolDetails["outs"][number]>,
  speedCount: {
    required: true,
    type: Number,
  },
});

const emit = defineEmits(["change"]);

const options = computed(() =>
  Array(props.speedCount + 1)
    .fill(0)
    .map((_, i) => ({ value: String(i), label: i === 0 ? "OFF" : String(i) }))
);

const selected = computed(() => String(props.out?.status ?? 0));
</script>

<template>
  <KlereoSegmentedControl
    :model-value="selected"
    :options="options"
    @update:model-value="emit('change', Number($event))"
  />
</template>
